export default  {
  notFound: '404 НЕ НАЙДЕНО',
};
